<template>
  <el-dialog title="问题上报办理" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form2" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="handleType" label="办理类型">

              <el-select v-model="formData.handleType" disabled placeholder="请选择办理类型">
                <el-option v-for="(item, index) of typeArr" :value="item.value" :label="item.label"
                  :key="index"></el-option>

              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="24" v-if="formData.handleType != '4'">
            <el-form-item prop="userId" :label="status == '2'?'验收人员':'下一步处理人'">

              <el-select v-model="formData.userId" clearable filterable  placeholder="请选择下一步处理人">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                  :key="index"></el-option>

              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item prop="feedbackContent"
              :label="formData.handleType == '1' ? '处理内容' : formData.handleType == '4' ? '审批意见' : '办理内容'">
              <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入 "
                v-model="formData.feedbackContent">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="formData.handleType == '4'">
            <el-form-item prop="approvalResult" label="审批结果">

              <el-select v-model="formData.approvalResult" clearable  placeholder="请选择审批结果">
                <el-option v-for="(item, index) of resultArr" :value="item.value" :label="item.label"
                  :key="index"></el-option>

              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item label="附件">
              <el-col :span="24">
                  <div class="row-wrap">
                    <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                      <i class="el-icon-error close-icon" @click="delImage(formData.fileList.indexOf(item))"></i>
                      <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                        :preview-src-list="fileImgUrl" fit="cover" />
                    </div>

                    <el-upload class="upload-demo" :show-file-list="false" :action="$apis.common.uploadUrl"
                      :on-success="handleSuccess" :before-upload="beforeUpload" list-type="picture-card">
                      <i class="el-icon-plus"></i>
                      <div slot="tip" class="el-upload__tip">
                        图片大小不能超过10MB~
                      </div>
                    </el-upload>
                  </div>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>

  </el-dialog>
</template>
<script>

export default {
  props: {
    issueId: {
      type: String,
      default: ''
    },
    showDlg: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ''
    },
    handleType: {
      type: String,
      default: ''
    }

  },
  data () {
    return {
      resultArr: [
        {
          label: '通过',
          value: '1'
        },
        {
          label: '驳回',
          value: '2'
        }
      ],
      //  办理类型1处理2分配3转办4审批

      typeArr: [
        {
          label: '处理',
          value: '1'
        },
        {
          label: '分配',
          value: '2'
        },
        {
          label: '转办',
          value: '3'
        },
        {
          label: '审批',
          value: '4'
        }
      ],
      formData: {
        issueId: '',
        handleType: '',
        feedbackContent: '',
        userId: '',
        approvalResult: '',
        fileList: []
      },
      rules: {
        userId: [
          {
            required: true,
            message: '请选择下一步处理人',
            trigger: ['blur', 'change']
          }
        ],
        approvalResult: [
          {
            required: true,
            message: '请选择审批结果',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      userList: []
    }
  },
  computed: {
    fileImgUrl() {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  created () {
    this.formData.handleType = this.handleType
    this.formData.issueId = this.issueId
    this.loadUser()
  },
  methods: {
    loadUser () {
      this.$axios.get(this.$apis.patrolProblemReport.selectIparkUserByRole, {
        userType: '1'
      }).then(res => {
        this.userList = res || []
      })
      // this.$axios.get(this.$apis.system.selectSysUserByPage, {
      //   userType: '1'
      // }).then(res => {
      //   this.userList = res.list || []
      // })
    },

    handleSuccess (res) {
      this.formData.fileList.push(res.data)
    },
    delImage (index) {
      this.formData.fileList.splice(index, 1)
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
      }
      return isImage && isLt10M
    },

    handleClose () {
      this.$emit('update:showDlg', false)
    },
    submitDlg () {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true

        const url = this.$apis.patrolProblemReport.insertPaIssueFeedback
        this.$axios.post(url, this.formData).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
